export enum StepTypes {
  INTRO = "introduction",
  PROBLEM = "problem",
  ANSWER = "answer",
  RESULT = "result",
}

export type AnswerSheet = Record<number, number>;
